import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";
import { PageAIAgent } from "./PageAIAgent.js";
import { PageAPIConfig } from "./PageAPIConfig.js";
import { PageHealth } from "./PageHealth.js";
import { PageAgentStatus } from "./PageAgentStatus.js";

export function PageAIConfig({vulns,user}){
  var T=React.useContext(ThemeCtx).T;
  var _tab=useState("agent"); var tab=_tab[0]; var setTab=_tab[1];
  var PURPLE="#A100FF";
  var tabs=[["agent","AI Agent"],["apiconfig","API Config"],["health","Health Check"],["status","Agent Status"]];
  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:0}},
    React.createElement("div",{style:{display:"flex",borderBottom:"1px solid "+T.border,marginBottom:12,gap:0}},
      tabs.map(function(t){
        return React.createElement("button",{key:t[0],onClick:function(){setTab(t[0]);},
          style:{padding:"10px 20px",background:"transparent",border:"none",
            borderBottom:tab===t[0]?"2px solid "+PURPLE:"2px solid transparent",
            color:tab===t[0]?PURPLE:T.text3,cursor:"pointer",fontSize:13,
            fontWeight:tab===t[0]?700:400}},t[1]);
      })
    ),
    tab==="agent"    &&React.createElement(PageAIAgent,    {vulns:vulns}),
    tab==="apiconfig"&&React.createElement(PageAPIConfig,  {user:user}),
    tab==="health"   &&React.createElement(PageHealth,     {}),
    tab==="status"   &&React.createElement(PageAgentStatus,{})
  );
}
